import { Time } from "@angular/common";

/**
 * Used to parse strings into dates/times.
 */
export class DateTimeParser {

// #region [ Static Methods ]

	/**
	 * Creates a Date from a date string and adjusts for any timezone offset.
	 *
	 * @param DateString The string representing the date.
	 * @returns A Date object derived from the DateString parameter, or null.
	 */
	public static ParseStringDate(DateString: string): Date {
		let datTemp: Date;
		let intDate: number;

		try {
			intDate = Date.parse(DateString);
			if (intDate > 0) {
				datTemp = new Date(intDate);

				return datTemp;
			}
			else
				return null;
		}
		catch {
			return null;
		}
	}

	/**
	 * Formats a Time object as a string using military time.
	 *
	 * @param TimeValue The Time object to convert to a string.
	 * @returns A string representation of the time.
	 */
	public static TimeToString(TimeValue: Time): string {
		let strHours, strMinutes: string;

		if (TimeValue.hours < 10)
			strHours = "0" + TimeValue.hours.toString();
		else
			strHours = TimeValue.hours.toString();

		if (TimeValue.minutes < 10)
			strMinutes = "0" + TimeValue.minutes.toString();
		else
			strMinutes = TimeValue.minutes.toString();

		return strHours + ":" + strMinutes;
	}

	/**
	 * Formats a Date object as a string with leading zeros.
	 *
	 * @param DateValue The Date object to convert to a string.
	 * @returns A string representation of the date.
	 */
	public static DateToString(DateValue: Date): string {
		let strMonth, strDay, strYear: string;

		if (DateValue.getMonth() < 9)
			strMonth = "0" + (DateValue.getMonth() + 1).toString();
		else
			strMonth = (DateValue.getMonth() + 1).toString();

		if (DateValue.getDate() < 10)
			strDay = "0" + DateValue.getDate().toString();
		else
			strDay = DateValue.getDate().toString();

		strYear = DateValue.getFullYear().toString();

		return strMonth + "/" + strDay + "/" + strYear;
	}

}
